import { CenterToJourneyRequestInput } from '../../lib/types/models/center-to-journey/center-to-journey-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type SuggestedTripPlaces = {
  tripId: number
  places: number
  staffsRequired: number
}

export type SuggestTripPlacesValuesInput = {
  centerToJourneys: CenterToJourneyRequestInput[]
  numberOfStaffs: number
}

export const suggestTripPlaceValues = async (input: SuggestTripPlacesValuesInput) => {
  return restApiClient
    .url(constructApiUrl(API.centers.suggestTripPlaceValues.url, null))
    .post<SuggestedTripPlaces[], SuggestTripPlacesValuesInput>(input)
}
